import { render, staticRenderFns } from "./ClearCache.vue?vue&type=template&id=149fdba3&scoped=true&"
import script from "./ClearCache.vue?vue&type=script&lang=js&"
export * from "./ClearCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149fdba3",
  null
  
)

export default component.exports